var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"page-loader__spinner"},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke-width":"2","stroke-miterlimit":"10"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }